import React from 'react';
import { AppSection, AppTitle } from '../Conditions/Conditions';
import { Container } from 'react-bootstrap';
import { FranchisePartners as FranchisePartnersComponent } from '../../components';
import styled from 'styled-components';

const FranchisePartners = () => {
  return (
    <GrayAppSection>
      <Container>
        <AppTitle>Партнеры франшизы</AppTitle>
        <FranchisePartnersComponent />
      </Container>
    </GrayAppSection>
  );
};

export const GrayAppSection = styled(AppSection)`
  background: #e7e8eb;
`;

export default FranchisePartners;
